import { useQuery } from "@tanstack/react-query";

import { getOrganizationProperty, getProperty } from "api/properties";
import { queryKeys } from "./queryKeys";

interface UseGetPropertyOptions {
  enabled?: boolean;
  organizationScope?: boolean;
}

export const useGetProperty = (
  propertyId: string,
  options: UseGetPropertyOptions = {},
) => {
  const { enabled = true, organizationScope = false } = options;

  return useQuery({
    queryKey: organizationScope
      ? [...queryKeys.properties.detail(propertyId), "organization"]
      : queryKeys.properties.detail(propertyId),
    queryFn: () =>
      organizationScope
        ? getOrganizationProperty(propertyId)
        : getProperty(propertyId),
    enabled: enabled && !!propertyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
